import { render, staticRenderFns } from "./myTab.vue?vue&type=template&id=2845dfc7&scoped=true"
import script from "./myTab.vue?vue&type=script&lang=js"
export * from "./myTab.vue?vue&type=script&lang=js"
import style0 from "./myTab.vue?vue&type=style&index=0&id=2845dfc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845dfc7",
  null
  
)

export default component.exports